// Slice 2 (workstream D): ONE atomic API call per repair / return-to-service journey.
// Replaces the fragile PUT(repair_status) + POST(signoff) + POST(rts) chain so a repair can
// never be left half-applied. Each of the three paths issues exactly one request.

// The job that was RAISED FROM this fault can close it atomically via /jobs/{jid}/close-fault.
// A job merely *linked* to the fault (added later) cannot, so we only pick a source job.
export function pickCloseFaultJob(fault) {
  const jobs = fault?.jobs || [];
  return (
    jobs.find((j) => j.source_fault_id === fault.id && j.status !== "completed") ||
    jobs.find((j) => j.source_fault_id === fault.id) ||
    null
  );
}

export async function submitFaultRepair(api, { fault, repairNotes = "", returnToService = false }) {
  const wantsRts = !!(returnToService && fault.asset_id);
  const job = pickCloseFaultJob(fault);

  if (job) {
    const res = await api.post(`/maintenance/jobs/${job.id}/close-fault`, {
      return_to_service: wantsRts,
      test_result: wantsRts ? (repairNotes || "Fault repaired") : undefined,
      comments: repairNotes || "Marked as repaired",
    });
    return { path: "close-fault", res };
  }

  if (wantsRts) {
    const res = await api.post(`/assets/${fault.asset_id}/return-to-service`, {
      fault_id: fault.id,
      test_result: repairNotes || "Fault repaired",
      comments: "Returned to service on fault repair",
      target_status_code: "available",
    });
    return { path: "return-to-service", res };
  }

  const res = await api.post(`/faults/${fault.id}/signoff`, {
    comments: repairNotes || "Marked as repaired",
  });
  return { path: "signoff", res };
}
